query totalTrafficByUtmSourceForCompany($input: TrafficCountInput) {
  totalTrafficByUtmSourceForCompany: totalTrafficByUtmSourceForCompany(input: $input) {
    utmKey
    values {
      label
      count
    }
  }
}
